/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { getDoc, doc, setDoc, Timestamp } from 'firebase/firestore';
import { validate as validateEmail } from 'email-validator';
import axios from 'axios';

import { ShareBar } from '..';
import { db, auth } from '../../firebase';
import style from './LoveMessage.module.less';

const SEND_EMAIL_URL = 'https://us-central1-eleven-puzzles-website.cloudfunctions.net/boxSendEmail2';
const SEND_EMAIL_TOKEN = 'EsKS5Cl6n244pvNf9DkGA6pc';

export const PLACEHOLDER = `Dear Puzzler,

There is nothing better than playing Online Escape Rooms. Should we play "Unboxing the mind of a Cryptic Killer" by Eleven Puzzles?

Let's meet online!

Yours truly,
EP`;

const SENDING_NONE = 0;
const SENDING_IN_PROGESS = 1;
const SENDING_SENT = 2;
const SENDING_ERROR = 3;

interface CreateMessageProps {
  messageId: string;
}

export const CreateMessage: React.FC<CreateMessageProps> = ({ messageId: userId }) => {
  const [recipientEmail, setRecipientEmail] = useState('');
  const [recipientEmailError, setRecipientEmailError] = useState('');
  const [sendingEmailStatus, setSendingEmailStatus] = useState(SENDING_NONE);
  const [message, setMessage] = useState('');
  const [name, setName] = useState('');

  const save = async() => {
    const docPath = `love-puzzle/${userId}`;
    const lovePuzzleDoc = await getDoc(doc(db, docPath));
    await setDoc(doc(db, docPath), {
      name,
      message,
      createdAt: lovePuzzleDoc.data()?.createdAt || Timestamp.now(),
      updatedAt: Timestamp.now()
    });
  };

  const sendEmail = async() => {
    const isEmailValid = validateEmail(recipientEmail);
    if (!isEmailValid) {
      setRecipientEmailError('Please provide a valid e-mail');
    } else {
      try {
        setSendingEmailStatus(SENDING_IN_PROGESS);
        await axios.post(SEND_EMAIL_URL, {
          token: SEND_EMAIL_TOKEN,
          email: recipientEmail,
          messageId: userId
        }, {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${(auth?.currentUser as any)?.accessToken}`
          }
        });
        setSendingEmailStatus(SENDING_SENT);
      } catch (err) {
        setSendingEmailStatus(SENDING_ERROR);
        console.error(err);
      }
    }
  };

  const onRecipientEmailChange = (email: string) => {
    setRecipientEmail(email);
    setRecipientEmailError('');
    setSendingEmailStatus(SENDING_NONE);
  };

  useEffect(() => {
    getDoc(doc(db, `love-puzzle/${userId}`))
      .then((ref) => {
        if (ref.exists()) {
          setMessage(ref.data().message);
          setName(ref.data().name);
        } else {
          save(); // save first, empty version
        }
      })
      .catch(err => console.error(err))
      .finally(() => console.log('done.'));
  }, []);

  return (
    <div className={style.adminContainer}>
      <h1 className={style.header}>Create your puzzle message</h1>

      <div className={classnames(style.row, style.previewRow, style.createMessage)}>
        <div className={style.text}>
          <div className={style.step}>
            <h2>Step 1: Customize your message</h2>

            <p>This message will be displayed to your recipient after all puzzles are solved.</p>

            <form
              className={style.form}
              onSubmit={ev => ev.preventDefault()}
              onBlur={() => save()}
            >
              <div className={style.textareaContainer}>
                <textarea
                  id="message-text"
                  name="message"
                  className={style.textInput}
                  placeholder="Type your message here..."
                  onChange={ev => setMessage(ev.target.value)}
                  value={message}
                />
              </div>
            </form>
          </div>

          <div className={style.step}>
            <h2>Step 2: Notify your recipient</h2>

            <p>Let us send the e-mail for you. We won't tell your recipient who you are ;)</p>

            <div className={style.form}>
              <div className={style.inputContainer}>
                <input
                  className={style.textInput}
                  type="email"
                  placeholder="Enter recipient's e-mail here..."
                  value={recipientEmail}
                  onChange={ev => onRecipientEmailChange(ev.target.value)}
                />
                {recipientEmailError ? <p className={style.error}>{recipientEmailError}</p> : <></>}
                <button
                  type="button"
                  className={style.copy}
                  disabled={[SENDING_IN_PROGESS, SENDING_SENT].indexOf(sendingEmailStatus) !== -1}
                  onClick={() => sendEmail()}
                >
                  {(() => {
                    if (sendingEmailStatus === SENDING_IN_PROGESS) {
                      return 'Sending...';
                    }
                    if (sendingEmailStatus === SENDING_SENT) {
                      return 'E-mail sent!';
                    }
                    if (sendingEmailStatus === SENDING_ERROR) {
                      return 'Failed to send, try again';
                    }
                    return 'Send the e-mail';
                  })()}
                </button>
              </div>
            </div>
          </div>

          <div className={style.step}>
            <h2>Step 3: Share the love!</h2>
            <p>Don't shy away from sharing this with others if you thought it was a fun way to reveal a message or a date location.</p>
            <ShareBar
              shareUrl="https://elevenpuzzles.com/message"
              title="I just created a Puzzle Box with a hidden message. Neat!"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
